import { render } from "./Switcher.vue?vue&type=template&id=569d6f47&scoped=true"
import script from "./Switcher.vue?vue&type=script&lang=js"
export * from "./Switcher.vue?vue&type=script&lang=js"

import "./Switcher.vue?vue&type=style&index=0&id=569d6f47&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569d6f47"]])

export default __exports__